<template>
  <div>
    <div v-if="subscriptionCancelledInfos && !unsubscriptionCancelledInfos"
         class="my-12 pa-6 cancelled-infos"
         v-style:border="`5px solid ${$finColors.accentRed}`"
         v-style:color="$finColors.accentRed">
      <p>
        Dein Abo {{ subscriptionCancelledInfos.productName }} für den Zeitraum
        vom {{ subscriptionCancelledInfos.periodStart | date }} bis zum
        {{ subscriptionCancelledInfos.periodEnd | date }}
        wurde gekündigt.</p>

      <p v-if="subscriptionCancelledInfos.periodEnd">
        Du kannst den vollen Umfang deines Abos noch bis zum
        {{ subscriptionCancelledInfos.periodEnd | date }} nutzen,
        danach wird dein Benutzerkonto auf das kostenlose <em>Basic</em> Abo heruntergestuft.
      </p>

      <p>
        Deine Kündigung kannst du <a @click="cancelUnsubscription">hier rückgängig</a> machen.
      </p>
    </div>

    <div v-if="unsubscriptionCancelledInfos"
         class="my-12 pa-6 cancelled-infos">
      <p>
        Die Kündigung deines Abos {{ unsubscriptionCancelledInfos.productName }} für den Zeitraum
        vom {{ unsubscriptionCancelledInfos.periodStart | date }} bis zum
        {{ unsubscriptionCancelledInfos.periodEnd | date }}
        wurde rückgängig gemacht.
      </p>
    </div>
  </div>
</template>


<script>
import {API, graphqlOperation} from "@/plugins/finAmplifyModules"
import {cancelUnsubscription} from "@/components/pages/profile/subscription/graphql"

export default {
  name: "FinCancellingWarning",
  props: {
    subscriptionCancelledInfos: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      unsubscriptionCancelledInfos: undefined
    }
  },
  methods: {
    async cancelUnsubscription() {
      await API.graphql(graphqlOperation(cancelUnsubscription)).then(res => {
        console.log("cancelUnsubscription res", res)
        this.unsubscriptionCancelledInfos = res.data.cancelUnsubscription
        this.$store.commit('auth/subscriptionChanged', res.data.cancelUnsubscription.metadata.groupId)
        this.$emit("unsubscriptionCancelledInfos", this.unsubscriptionCancelledInfos)
      }).catch(e => {
        console.error("Failed to cancel unsubscription", e)
      })
    }
  },
}
</script>


<style lang="scss" scoped>

.cancelled-infos {
  max-width: 75%;

  @media only screen and (max-width: 600px) {
    max-width: 100%;
  }

  p {
    margin: 0;
    font-weight: bold;
  }
}
</style>
